import React from "react";
import styled from "styled-components";
import injection1 from '../../images/cardesign/injection1.jpg'
;


const ArticleWrapper = styled.div`
  max-width: 800px;
  margin: auto;
  padding: 2rem;
  overflow-y: auto;
`;

const Img = styled.img`
  width: 100%;
  margin: 1rem 0;
`;


const FuelInjectionChapter=()=> (

   <ArticleWrapper>
      <h2>Airbag Systems: Design & Troubleshooting</h2>
      <p>
        Airbags are triggered by crash sensors that activate an igniter inside the inflator module. 
        The chemical reaction produces nitrogen gas, inflating the bag almost instantly.
      </p>
  
      <Img src={injection1} alt="Airbag Sensor Diagram" />
  
  
  
      <p>
        Common faults include broken sensor wires, failed igniters, and controller malfunctions. 
        Proper diagnostics start with the onboard error codes, often accessible via OBD systems.
      </p>
    </ArticleWrapper>  


)
  
export default FuelInjectionChapter